/**
* Membership Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Membership Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'membership-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      // BLUE BOTTOM BORDER ANIMATION
      $( '.blue-bottom-border' ).each( function() {
        gsap.from( this, {
          scrollTrigger: {
            trigger: this,
            start: 'top 70%',
            scrub: false,
            // markers: true,
          },
          onStart: () => {
            this.classList.add( 'action' );
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'membership-cards', COMPONENT );
} )( app );
